import styled from "styled-components";
import { font, theme } from "styles";

export const SelectOptionLabel = styled("span")`
  position: relative;
  font-size: 16px;
  font-weight: ${font.weight.regular};
  color: ${theme.selectOptionLabel.fontColor};
`;
